import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const firestore = getFirestore();

function EditServicio() {
    const { id } = useParams();
    const [state, setState] = useState({
        id: id,
        name: '',
        type: 'check',
        order: '',
        hogar: '',
        feriado_domingo_hogar: '',
        unidad_medida: 'Unitario',
        montoFijo: false,
        montoFijoValor: '',
        montoFijoFeriadoValor: '',
        submitted: false,
        spinner: true,
    });

    useEffect(() => {
        loadServicioAndPrecio();
    }, [id]);

    const loadServicioAndPrecio = async () => {
        try {
            const serviceDocRef = doc(firestore, 'servicios', String(id));
            const priceDocRef = doc(firestore, 'precios', String(id));

            const [serviceSnap, priceSnap] = await Promise.all([
                getDoc(serviceDocRef),
                getDoc(priceDocRef)
            ]);

            let serviceData = serviceSnap.exists() ? serviceSnap.data() : {};
            let priceData = priceSnap.exists() ? priceSnap.data() : {};

            setState(prevState => ({
                ...prevState,
                name: serviceData.name || priceData.descripcion || '',
                type: serviceData.type || 'check',
                order: serviceData.order !== undefined ? serviceData.order : id,
                hogar: priceData.hogar !== undefined ? priceData.hogar : '',
                feriado_domingo_hogar: priceData.feriado_domingo_hogar !== undefined ? priceData.feriado_domingo_hogar : '',
                unidad_medida: priceData.unidad_medida || 'Unitario',
                montoFijo: priceData.montoFijo === true || priceData.montoFijo === "true",
                montoFijoValor: priceData.montoFijoValor !== undefined ? String(priceData.montoFijoValor) : (priceData.hogar || ''),
                montoFijoFeriadoValor: priceData.montoFijoFeriadoValor !== undefined ? String(priceData.montoFijoFeriadoValor) : (priceData.feriado_domingo_hogar || priceData.montoFijoValor || priceData.hogar || ''),
                spinner: false,
            }));
        } catch (error) {
            console.error("Error al cargar servicio:", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const updateServicio = async () => {
        try {
            if (!state.name.trim()) {
                alert("El nombre del servicio no puede estar vacío");
                return;
            }

            setState(prevState => ({ ...prevState, spinner: true }));
            const serviceIdNum = parseInt(id, 10);

            // Actualizar documento de 'servicios'
            const serviceData = {
                id: serviceIdNum,
                name: state.name.trim(),
                type: state.type,
                order: Number(state.order),
            };
            await setDoc(doc(firestore, "servicios", String(id)), serviceData, { merge: true });

            // Actualizar documento de 'precios'
            const priceData = {
                id: serviceIdNum,
                descripcion: state.name.trim(),
                unidad_medida: state.unidad_medida || "Unitario",
                hogar: String(state.hogar || "0"),
                corporativo: "0",
                feriado_domingo_hogar: String(state.feriado_domingo_hogar || state.hogar || "0"),
                feriado_domingo_corporativo: "0",
                montoFijo: state.montoFijo === true,
                montoFijoValor: String(state.montoFijoValor || state.hogar || "0"),
                montoFijoFeriadoValor: String(state.montoFijoFeriadoValor || state.feriado_domingo_hogar || state.montoFijoValor || "0"),
            };
            await setDoc(doc(firestore, "precios", String(id)), priceData, { merge: true });

            setState(prevState => ({
                ...prevState,
                submitted: true,
                spinner: false,
            }));
        } catch (error) {
            console.error("Error al actualizar servicio:", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            {state.submitted ? (
                <div>
                    <Typography variant="h4" sx={{ mb: 2 }}>¡Servicio editado correctamente!</Typography>
                    <Button variant="contained" href="/servicios">
                        Ir a listado
                    </Button>
                </div>
            ) : (
                <div className="form-container">
                    {state.spinner ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                                Editar Servicio (ID: {id})
                            </Typography>
                            <div className="order-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="name"
                                            label="Nombre del servicio"
                                            value={state.name}
                                            name="name"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel id="type-label">Tipo de Control</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                id="type"
                                                name="type"
                                                value={state.type}
                                                onChange={onChangeValues}
                                                label="Tipo de Control"
                                            >
                                                <MenuItem value="check">Casilla de verificación (Check)</MenuItem>
                                                <MenuItem value="number">Numérico (Cantidad)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            id="order"
                                            label="Orden de visualización"
                                            type="number"
                                            value={state.order}
                                            name="order"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="hogar"
                                            label="Precio Cliente Hogar (Gs.)"
                                            type="number"
                                            value={state.hogar}
                                            name="hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="feriado_domingo_hogar"
                                            label="Precio Cliente Feriado/Domingo (Gs.)"
                                            type="number"
                                            value={state.feriado_domingo_hogar}
                                            name="feriado_domingo_hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={state.montoFijo}
                                                    onChange={(e) => setState(prev => ({
                                                        ...prev,
                                                        montoFijo: e.target.checked,
                                                        montoFijoValor: e.target.checked && !prev.montoFijoValor ? prev.hogar : prev.montoFijoValor,
                                                        montoFijoFeriadoValor: e.target.checked && !prev.montoFijoFeriadoValor ? (prev.feriado_domingo_hogar || prev.hogar) : prev.montoFijoFeriadoValor
                                                    }))}
                                                    color="primary"
                                                />
                                            }
                                            label="Activar Monto Fijo (Cuadrilla)"
                                        />
                                    </Grid>
                                    {state.montoFijo && (
                                        <>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    id="montoFijoValor"
                                                    label="Monto Fijo Semana (Gs.)"
                                                    type="number"
                                                    value={state.montoFijoValor}
                                                    name="montoFijoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en días hábiles que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    id="montoFijoFeriadoValor"
                                                    label="Monto Fijo Domingo / Feriado (Gs.)"
                                                    type="number"
                                                    value={state.montoFijoFeriadoValor}
                                                    name="montoFijoFeriadoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en domingos o feriados que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    onClick={updateServicio}
                                    sx={{ mt: 3 }}
                                >
                                    Guardar Cambios
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default EditServicio;
